import React from "react";
import styles from "./EnquiryInformation.module.css"
import {Section} from "../../../../../elements/section/Section";
import {FullLocationUi} from "../../../../../../api/generated";
import {TextField} from "../../../../../elements/textField/TextField";
import {
    getEnquiryProviderName
} from "../../../../assistant/modal/createAndUpdate/components/util/enquiryProviderUtil";

interface LocationDetailsProps {
    location: FullLocationUi
}

export const EnquiryInformation: React.FC<LocationDetailsProps> = ({
                                                                        location
                                                                    }) => {

    return <Section title={"Enquiry Information"}>
        <div className={styles.fieldsWrapper}>
            <div className={styles.wrapper}>
                <TextField title={"Enquiry Platform Provider"} value={getEnquiryProviderName(location.enquiryProvider)}/>
                {location.dragon2000DealerId && <TextField title={"Dealer ID"} value={location.dragon2000DealerId}/>}
                {location.em2Region && <TextField title={"Region"} value={location.em2Region}/>}
            </div>
        </div>
    </Section>
}
